import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import MedicineService from '../../../services/medicineService';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { SyncSettingsModel } from "../../../models/dataSynchronization";
import { Dropdown } from 'primereact/dropdown';
// import { NotificationScheduleType, NotificationAlarmType, NotificationFrequency } from "../../../common/enums";
import { DropdownModel } from "../../../models/dropdownModel";
import { enumToDropdownArray, fomatDateAsString, formatAlarmTime, fomatDateTimeAsString } from '../../../common/functions/helperFunctions';
import { Calendar } from 'primereact/calendar';
import { Spinner } from 'primereact/spinner';
import { Checkbox } from 'primereact/checkbox';
import { DataSourceType } from '../../../common/enums';
import { InputTextarea } from 'primereact/inputtextarea';

interface IProps {
  syncSettings: SyncSettingsModel,
  isVisible: boolean,
  cancelClick: any,
  saveClick: any,
  // lang: string
}

interface IState {
  isLoading: boolean;
  error: any;
  validationMessage: string;
  syncSettings: SyncSettingsModel,
  dataSourceTypeDropdown: Array<DropdownModel>,
  emaFileURL: string
}


class SyncSettingsAddEditDialog extends React.Component<IProps, IState> {
  medicineService = new MedicineService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      validationMessage: '',
      syncSettings: this.props.syncSettings,
      dataSourceTypeDropdown: new Array<DropdownModel>(0),
      emaFileURL: "https://www.ema.europa.eu/sites/default/files/Medicines_output_european_public_assessment_reports.xlsx"
    }
  }

  componentDidMount() {
    this.initData();
  }

  initData() {
    let dataSourceTypeDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }].concat(enumToDropdownArray(DataSourceType, true));
    let syncSettings = { ...this.state.syncSettings }

    if (syncSettings && syncSettings.syncSettingsId) { //Edit init for time only
      let syncStartTime = formatAlarmTime(syncSettings.syncStartTime);
      let today = fomatDateAsString(new Date());
      let syncDateTime = today + " " + syncStartTime;

      syncSettings.syncStartTime = syncDateTime;
    }
    else { //Add init for all properties
      let today = fomatDateAsString(new Date());
      let syncStartTime = fomatDateTimeAsString(new Date());

      syncSettings.startDate = today;
      syncSettings.syncStartTime = syncStartTime;
      syncSettings.frequencyCounter = 1;
    }

    this.setState({
      syncSettings: syncSettings,
      dataSourceTypeDropdown: dataSourceTypeDropdown
    });
  }


  handleChange = (key, value) => {
    const syncSettings: SyncSettingsModel = { ...this.state.syncSettings };
    syncSettings[key] = value;

    this.setState({
      syncSettings: { ...syncSettings }
    });

    // this.handleSummaryContent(currentUserNotification);
  };

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleSaveButton = event => {
    let syncSettings: SyncSettingsModel = { ...this.state.syncSettings };

    syncSettings.fileURL = this.state.emaFileURL;
    syncSettings.startDate = fomatDateAsString(new Date(syncSettings.startDate));
    syncSettings.syncStartTime = formatAlarmTime(syncSettings.syncStartTime);

    this.props.saveClick(syncSettings);
  }

  render() {

    let { error, dataSourceTypeDropdown, emaFileURL, syncSettings } = this.state;

    return (
      <Dialog
        header={Translate('Scheduler Settings')}
        responsive={true}
        width="50%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCancelButton}
        footer={
          <div>
            <Button label={Translate('Save')} icon="pi pi-check" onClick={this.handleSaveButton} className="p-button-raised" />
            <Button label={Translate('Cancel')} icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        <div style={{ minHeight: '450px', maxHeight: '700px' }}>
          {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
          {error && error.message ? <AlertMessage type='danger'>{error.message}</AlertMessage> : null}

          <Toolbar style={{ marginBottom: '2px' }}>
            <div className="p-grid p-fluid p-md-12">
              <div className="p-col-12 p-md-12">
                <label>{Translate('File URL')}:</label>
                <InputText
                  readOnly={true}
                  style={{ width: '100%' }}
                  value={emaFileURL}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>{Translate('Data Source Type')}:</label>
                <Dropdown
                  value={1}
                  options={dataSourceTypeDropdown}
                  disabled={true}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>{Translate('Start Date')}:</label>
                <Calendar
                  // dateFormat={getCalendarCultureView(this.props.lang)}
                  showButtonBar={true} monthNavigator={true} yearNavigator={true} yearRange="1950:2050"
                  showIcon={true} readOnlyInput={true}
                  value={syncSettings.startDate ? new Date(syncSettings.startDate) : new Date()}
                  onChange={(e) => this.handleChange('startDate', e.value)}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>{Translate('Start Time')}:</label>
                <Calendar
                  showButtonBar={true} timeOnly={true} showTime={true} hourFormat="24" showIcon={true}
                  readOnlyInput={true}
                  value={syncSettings.syncStartTime ? new Date(syncSettings.syncStartTime) : new Date()}
                  onChange={(e) => this.handleChange('syncStartTime', e.value)}
                />
              </div>
              <div className="p-col-12 p-md-3">
                <label>{Translate('Recurs every day(s)')}:</label>
                <Spinner
                  value={syncSettings.frequencyCounter ? syncSettings.frequencyCounter : 1}
                  onChange={(e) => this.handleChange('frequencyCounter', e.value)}
                  min={1}
                  max={365} />
              </div>
              <div className="p-col-12 p-md-12">
                <label>{Translate('Description')}:</label>
                <InputTextarea
                  rows={3}
                  style={{ width: '100%' }}
                  value={syncSettings && syncSettings.description ? syncSettings.description : ""}
                  onChange={(e) => this.handleChange('description', e.target['value'])}
                />
              </div>
            </div>
          </Toolbar>
        </div>
      </Dialog >
    )
  }
}

export default SyncSettingsAddEditDialog;